import {Component} from '@angular/core';

import {DictService} from '../../../../core/ecv-http-services/services/dict.service';
import {DictModel} from '../../../../dictionary/dict.model';
import {BaseFillDataFormComponent} from '../../../../widgets/form-section/base-fill-data-form-component';
import {EcvLanguageService} from '../../../../core/ecv-language.service';
import {ClientInterviewStatus} from '../../../../enums/client-interview-status.enum';


@Component({
  selector: 'app-client-questionnaire-history-data',
  templateUrl: './client-interview-questionnaire-history.component.html'
})
export class ClientInterviewQuestionnaireHistoryComponent extends BaseFillDataFormComponent {

  Array = Array;
  pendingDict: number[] = [];

  constructor(private dictService: DictService, private langService: EcvLanguageService) {
    super();
  }

  getCompetenceName(index: number): string {
    if (!this.data.competenceRates[index] || !this.data.competenceRates[index].competenceDictId) {
      return '';
    }
    if (!this.data.competenceRates[index].competenceDict) {
      this.data.competenceRates[index].competenceDict = new DictModel();
      if (this.pendingDict.find(x => x === this.data.competenceRates[index].competenceDictId)) {
        return '';
      }
      this.pendingDict.push(this.data.competenceRates[index].competenceDictId);
      this.dictService.getDictionary(this.data.competenceRates[index].competenceDictId).subscribe(response => {
        this.data.competenceRates[index].competenceDict = response;
      });
      return '';
    }
    if (!this.data.competenceRates[index].competenceDict.id) {
      return '';
    }
    return this.langService.pickFromDictionary(this.data.competenceRates[index].competenceDict);

  }

  getCandidateStatusType() {
    return ClientInterviewStatus[this.data.statusType];
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/interviews/questionnaires/client-interview-questionnaire/history/client-interview-questionnaire-history.component.ts